
export default {
  data() {
    return {
      showBanner: false,
      isOnline: true
    };
  },
  created() {
    window.addEventListener("online", this.onlineAction);
    window.addEventListener("offline", this.offlineAction);
  },
  computed: {
    getColor() {
      return this.isOnline ? "green" : "red";
    }
  },
  methods: {
    onlineAction() {
      this.isOnline = true;
      setTimeout(
        (() => {
          this.showBanner = false;
        }).bind(this),
        3000
      );
    },
    offlineAction() {
      this.showBanner = true;
      this.isOnline = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("online", this.onlineAction);
    window.removeEventListener("offline", this.offlineAction);
  }
};
